import { InjectionToken, inject } from "@angular/core";
import { AppUtil } from "src/app/core/utils/utils";
import { config } from "src/assets/config/config";
import { Country } from 'src/app/shared/country.type';
let country: Country = (window as any)['country'] ? (window as any)['country'] as Country : 'us';
export const SERVICE_GLOBAL = new InjectionToken("configuration", {
  factory: () => {
    const baseURL = AppUtil.getAPIBaseUrl();
    const oktaBaseUrl = AppUtil.getOktaBaseUrl();
    return {
      HOME_DATA_EN: baseURL + "/ivr/getEnglishChannelMap",
      HOME_DATA: baseURL + config[country]?.apiEndPointList?.channelMap,
      SFDC_DATA: baseURL + config[country]?.apiEndPointList?.sfdcArticles,
      LOGIN: baseURL + config[country]?.apiEndPointList?.loginToken,
      CREATE_CASE: baseURL + config[country]?.apiEndPointList?.createCase,
      ATTACHMENT_UPLOAD: baseURL + config[country]?.apiEndPointList?.attachmentUpload,
      CUSTOMER_GAUGE: baseURL + config[country]?.apiEndPointList?.updateThumbsUp,

      /* Okta URLs */
      OKTA_AUTHORIZE: oktaBaseUrl + "/authorize",
      OKTA_LOGOUT: oktaBaseUrl + "/logout",

      /* Five9 URL */
      FIVE9_URL: baseURL + config[country]?.apiEndPointList?.five9Url,

      /* Create SSO URLs*/
      CREATE_SSO_USER: baseURL + config[country]?.apiEndPointList?.createSSoUser,
      GET_USER: baseURL + config[country]?.apiEndPointList?.getUser,
      ADD_PRODUCT_ACCESS: baseURL + config[country]?.apiEndPointList?.addProductAccess,

      /* Search URLs */
      GET_TITLES: baseURL + config[country]?.apiEndPointList?.searchTitles,
      GET_SEARCH_DATA: baseURL + config[country]?.apiEndPointList?.getSearchData,
      GET_ALL_SEARCH_DATA: baseURL + config[country]?.apiEndPointList?.getAllSearchData,
      GET_TAB_DETAILS: baseURL + config[country]?.apiEndPointList?.getTabDetails,

      /* Product URLs */
      GET_REASON_DESCRIPTION: baseURL + config[country]?.apiEndPointList?.getReasonDetails,

      /* Case URLs */
      GET_CASE_STATUS: baseURL + config[country]?.apiEndPointList?.getCaseStatus,
      UPDATE_CASE_STATUS: baseURL+ config[country]?.apiEndPointList?.updateCaseStatus,

      SEND_FEEDBACK: "https://iad1.qualtrics.com/API/v3/surveys/SV_88kKYJlmmV55JlQ/responses"
    };
  }
});
